// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2QYKH","sendOtp":"AuthorizeToLogin_sendOtp__2Q8NG"};